// src/utils/cn.js
export const cn = (...classNames) => {
  return classNames.filter(Boolean).join(" ");
};
